"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[SignalingClientJoin]] contains settings for the Join SignalFrame.
 */

var SignalingClientJoin =
/** Initializes a SignalingClientJoin with the given properties.
 *
 * // maxVideos is deprecated as the video sending/receiving capacity limits
 * // for a meeting will be controlled by the backend.
 * @param maxVideos Usage of maxVideos variable will result into no-op.
 * @param sendBitrates Whether the server should send Bitrates messages.
 * @param applicationMetadata [[ApplicationMetadata]].
 */
function SignalingClientJoin(maxVideos, sendBitrates, applicationMetadata) {
  _classCallCheck(this, SignalingClientJoin);

  this.maxVideos = maxVideos;
  this.sendBitrates = sendBitrates;
  this.applicationMetadata = applicationMetadata;
};

exports.default = SignalingClientJoin;